"use strict";
// Property can exist but be undefined or null
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperty = void 0;
const rangeVariables_1 = require("./rangeVariables");
// If property is not available, indicate error
const getProperty = (obj, propertyKey, { joinKey = '.', rangeVariable = false, } = {}) => {
    let sanitizedPropertyKey = propertyKey;
    if (rangeVariable) {
        sanitizedPropertyKey = (0, rangeVariables_1.extractVariableNameFromRange)(propertyKey);
    }
    // Handle flattened objects first
    if (sanitizedPropertyKey in obj) {
        return { error: false, value: obj[sanitizedPropertyKey] };
    }
    // Handle objects
    // Keys may also contain the join key
    const splitKeys = sanitizedPropertyKey.split(joinKey);
    const keys = [];
    let currentSplitKey = splitKeys.shift();
    // eslint-disable-next-line no-restricted-syntax, no-cond-assign
    while (currentSplitKey !== undefined) {
        keys.push(currentSplitKey);
        const joinedKey = keys.join(joinKey);
        if (joinedKey in obj) {
            const value = obj[joinedKey];
            // Object type (not null or array)
            if (typeof value === 'object' &&
                value !== null &&
                !Array.isArray(value)) {
                // If there are still keys remaining, recursively search
                if (splitKeys.length) {
                    return (0, exports.getProperty)(value, // Making an assumption that keys are string
                    splitKeys.join(joinKey));
                }
                // Otherwise, return the desired object
                // Throw error for now until object inputs are supported
                return { error: false, value };
            }
            // At this stage, value is not an object with properties
            // If there are still more keys, return an error
            if (splitKeys.length) {
                return { error: true, value: undefined };
            }
            // Otherwise, return value
            return { error: false, value };
        }
        currentSplitKey = splitKeys.shift();
    }
    // Nothing found, return an error
    return { error: true, value: undefined };
};
exports.getProperty = getProperty;
//# sourceMappingURL=formulaInput.js.map